















import Vue from 'vue';
import VeMap from 'v-charts/lib/map.common';
import 'echarts/lib/component/title';
import customerClient from '../../../apis';
import 'echarts/lib/component/visualMap';
import customerVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    VeMap,
  },
  data() {
    return {
      mapExtend: {
        geo: {
          aspectScale: 0.75,
        },
      },
      chartData: {
        columns: ['province', 'count'],
        rows: [
          { province: '吉林', count: 0 },
          { province: '北京', count: 0 },
          { province: '上海', count: 0 },
          { province: '浙江', count: 0 },
          { province: '天津', count: 0 },
          { province: '重庆', count: 0 },
          { province: '河北', count: 0 },
          { province: '河南', count: 0 },
          { province: '云南', count: 0 },
          { province: '辽宁', count: 0 },
          { province: '黑龙江', count: 0 },
          { province: '湖南', count: 0 },
          { province: '安徽', count: 0 },
          { province: '山东', count: 0 },
          { province: '新疆', count: 0 },
          { province: '江苏', count: 0 },
          { province: '江西', count: 0 },
          { province: '湖北', count: 0 },
          { province: '广西', count: 0 },
          { province: '甘肃', count: 0 },
          { province: '山西', count: 0 },
          { province: '内蒙古', count: 0 },
          { province: '陕西', count: 0 },
          { province: '福建', count: 0 },
          { province: '贵州', count: 0 },
          { province: '广东', count: 0 },
          { province: '青海', count: 0 },
          { province: '西藏', count: 0 },
          { province: '四川', count: 0 },
          { province: '宁夏', count: 0 },
          { province: '海南', count: 0 },
          { province: '台湾', count: 0 },
          { province: '香港', count: 0 },
          { province: '澳门', count: 0 },
        ],
      },
      chartSettings: {
        position: 'china',
        label: {
          normal: {
            show: false,
          },
          emphasis: {
            show: true,
          },
        },
        labelMap: {
          count: '人数',
        },
      },
      title: {
        text: '地区分布',
        left: 'center',
        top: 50,
        textStyle: {
          color: '#000',
          fontSize: 14,
        },
      },
      chartVisualMap: {
        min: 0,
        max: 5000,
        show: false,
        inRange: {
          color: ['#E5F0FA', '#629FE0'],
        },
      },
      loading: false,
    };
  },
  methods: {
    afterConfig(options: any)  {
      options.legend = null;
      return options;
    },
    getCount(item: any, datas: any) {
      const data = datas.find((r: any) => r.province === item.province);
      if (data) {
        return {province: item.province, count: data.count};
      } else {
        return {province: item.province, count: 0};
      }
    },
    getProvinceData() {
      customerClient.getProvinceGroup(this.customerState.customerQuery).success((r) => {
        if (r.data) {
          this.chartData.rows = this.chartData.rows.map((d: any) => this.getCount(d, r.data));
          this.chartVisualMap.max = Math.max(r.data.map((r: any) => r.count));
          this.loading = false;
        }
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.getProvinceData();
  },
});
